/* 

  HEADS UP! THIS IS A GENERATED FILE!
  
  Changes done in this file will be overwritten on next generation from the code generator.

*/
import { DateRangePicker, NumberFilterInput } from 'components/filters';
import { InvoiceSelect, OrderSelect } from 'components/Selects';
import { SecureFormsy, Select } from 'flaivy-react/components/inputs';
import RequiresRole from 'flaivy-react/components/RequiresRole';
import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import {
  Button,
  ButtonGroup,
  Col,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from 'reactstrap';
/* eslint-enable */
import { resolve as orderResolve } from '../../shared/actions/generated/order.actions';

// eslint-disable-next-line
async function resolveQuery(query) {
  const resolvedQuery = { ...query };
  // eslint-disable-next-line
  if (query.order) {
    resolvedQuery.order = await orderResolve(query.order);
  }
  return resolvedQuery;
}

const defaultActionValues = () => ({});

function ComplaintFilterPanel({
  querySpecification,
  onChange,
  isSubForm,
  isModal,
  // eslint-disable-next-line
  immutableQuery,
}) {
  const [state, setState] = useState({
    querySpecification,
  });

  useEffect(() => {
    async function getResolvedQuery() {
      const fullyResolvedFilter = await resolveQuery(querySpecification || []);
      setState({
        querySpecification: {
          ...(querySpecification || defaultActionValues()),
        },
        resolvedQuery: {
          ...(fullyResolvedFilter || defaultActionValues()),
        },
      });
    }
    if (querySpecification) {
      getResolvedQuery();
    }
    /* eslint-disable-next-line */
  }, []);

  /* eslint-disable-next-line */
  const handleChange = async (key, value) => {
    const { querySpecification, resolvedQuery } = state;

    const newQuerySpecification = { ...querySpecification };
    const newResolvedQuery = { ...resolvedQuery };

    const isEmptyChild =
      (Array.isArray(value) && value.length === 0) ||
      (_.isObject(value) && (_.isEmpty(value) || value.iLike === '%'));

    const isEmptyValue =
      value === null ||
      value === undefined ||
      value === '' ||
      value === '<NULL>' ||
      value === '%' ||
      isEmptyChild;
    if (isEmptyValue) {
      delete newQuerySpecification[key];
      delete newResolvedQuery[key];
    } else {
      newQuerySpecification[key] = value;
      newResolvedQuery[key] = value;
    }

    setState({
      querySpecification: newQuerySpecification,
      resolvedQuery: newResolvedQuery,
    });
    // eslint-disable-next-line
    await onChange(newQuerySpecification);
  };

  const reset = async () => {
    setState({
      querySpecification: { ...immutableQuery },
      resolvedQuery: {},
    });
    // eslint-disable-next-line
    await onChange({});
  };

  /* eslint-disable no-unused-vars */
  const { resolvedQuery } = state;
  /* eslint-enable */

  return (
    <>
      <SecureFormsy isSubForm={isSubForm}>
        {!isModal && (
          <Button onClick={reset} className="my-2" color="secondary" block>
            Rensa filter
          </Button>
        )}

        {typeof immutableQuery.complaintNumber === 'undefined' && (
          <FormGroup>
            <Label>Reklamationsnummer</Label>
            <NumberFilterInput
              name="complaintNumber"
              value={_.get(resolvedQuery, 'complaintNumber')}
              onChange={handleChange}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.complaintDate === 'undefined' && (
          <FormGroup>
            <Label>Reklamationsdatum</Label>
            <DateRangePicker
              name="complaintDate"
              value={_.get(resolvedQuery, 'complaintDate')}
              onChange={handleChange}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.resolution === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.order === 'undefined' && (
          <FormGroup>
            <Label>Order</Label>
            <OrderSelect
              defaultOptions={false}
              instanceId="select-order"
              name="order"
              value={_.get(resolvedQuery, 'order')}
              onChange={handleChange}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.cancelled === 'undefined' && (
          <FormGroup>
            <Label>Makulerad</Label>
            <br />
            <ButtonGroup>
              <Button
                color="secondary"
                active={_.get(resolvedQuery, 'cancelled') === undefined}
                onClick={() => {
                  handleChange('cancelled', undefined);
                }}
              >
                Alla
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'cancelled') === true ||
                  _.get(resolvedQuery, 'cancelled') === 'true'
                }
                onClick={() => {
                  handleChange('cancelled', true);
                }}
              >
                Ja
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'cancelled') === false ||
                  _.get(resolvedQuery, 'cancelled') === 'false'
                }
                onClick={() => {
                  handleChange('cancelled', false);
                }}
              >
                Nej
              </Button>
            </ButtonGroup>
          </FormGroup>
        )}

        {typeof immutableQuery.contactName === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.contactPhone === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.contactEmail === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.complaintType === 'undefined' && (
          <FormGroup>
            <Label>Ärendetyp</Label>
            <Select
              type="string"
              instanceId="select-complaintType"
              name="complaintType"
              value={_.get(resolvedQuery, 'complaintType')}
              onChange={handleChange}
              options={[
                {
                  label: 'Fel order levererades',
                  value: 'customerGotWrongOrder',
                },
                { label: 'Fel artiklar levererades', value: 'wrongArticles' },
                { label: 'Fel pris', value: 'wrongPrices' },
                { label: 'Saknas artiklar på order', value: 'missingArticles' },
                {
                  label: 'Artiklar gick sönder i leverans',
                  value: 'articlesBrokenInTransport',
                },
                {
                  label: 'Artikeln tillfredställer inte kvalitetskrav',
                  value: 'articleDoesNotMeetQualityExpectations',
                },
                { label: 'Leveransen är försvunnen', value: 'lostInDelivery' },
                {
                  label: 'Ordern blev så sen så att den inte längre är aktuell',
                  value: 'cancelledDueToLateHandling',
                },
                { label: 'Annat', value: 'other' },
                { label: 'Alla', value: undefined },
              ]}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.resolutionType === 'undefined' && (
          <FormGroup>
            <Label>Åtgärdstyp</Label>
            <Select
              instanceId="select-resolutionType"
              name="resolutionType"
              value={_.get(resolvedQuery, 'resolutionType', '')}
              onChange={handleChange}
              options={[
                {
                  value: 'credit',
                  label:
                    'Krediterad - vi får inte tillbaka artiklarna' || 'credit',
                },
                {
                  value: 'return',
                  label: 'Krediterad - retur bokad' || 'return',
                },
                {
                  value: 'customerPayed',
                  label: 'Kunden köper extra produkterna' || 'customerPayed',
                },
                {
                  value: 'other',
                  label: 'Annat - manuell hantering av ekonomi' || 'other',
                },
                { value: 'none', label: 'Ingen åtgärd' || 'none' },
                { label: 'Alla', value: undefined },
              ]}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.description === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.assignedResponsibility === 'undefined' && (
          <FormGroup>
            <Label>Ersättningsansvarig</Label>
            <Select
              instanceId="select-assignedResponsibility"
              name="assignedResponsibility"
              value={_.get(resolvedQuery, 'assignedResponsibility', '')}
              onChange={handleChange}
              options={[
                {
                  value: 'warehouse',
                  label: 'Vinden - faktura sker direkt' || 'warehouse',
                },
                {
                  value: 'supplier',
                  label:
                    'Leverantör - ersättning hanteras i avräkning' ||
                    'supplier',
                },
                { value: 'flaivy', label: 'Flaivy' || 'flaivy' },
                { value: 'none', label: 'Ingen' || 'none' },
                { label: 'Alla', value: undefined },
              ]}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.resolutionDate === 'undefined' && (
          <FormGroup>
            <Label>Avslutad</Label>
            <DateRangePicker
              name="resolutionDate"
              value={_.get(resolvedQuery, 'resolutionDate')}
              onChange={handleChange}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.complaintState === 'undefined' && (
          <FormGroup>
            <Label>Status</Label>
            <Select
              instanceId="select-complaintState"
              name="complaintState"
              value={_.get(resolvedQuery, 'complaintState', '')}
              onChange={handleChange}
              options={[
                { value: 'received', label: 'Mottagen' || 'received' },
                { value: 'inReview', label: 'Granskas' || 'inReview' },
                { value: 'resolved', label: 'Klar' || 'resolved' },
                { label: 'Alla', value: undefined },
              ]}
            />
          </FormGroup>
        )}

        <RequiresRole requiredRoles={['super']}>
          {typeof immutableQuery.customerAdjustmentInvoice === 'undefined' && (
            <FormGroup>
              <Label>Kreditfaktura mot kund</Label>
              <InvoiceSelect
                defaultOptions={false}
                instanceId="select-customerAdjustmentInvoice"
                name="customerAdjustmentInvoice"
                value={_.get(resolvedQuery, 'customerAdjustmentInvoice')}
                onChange={handleChange}
              />
            </FormGroup>
          )}
        </RequiresRole>

        <RequiresRole requiredRoles={['super']}>
          {typeof immutableQuery.freightClaimsInvoice === 'undefined' && (
            <FormGroup>
              <Label>Faktura mot vinden för ersättning</Label>
              <InvoiceSelect
                defaultOptions={false}
                instanceId="select-freightClaimsInvoice"
                name="freightClaimsInvoice"
                value={_.get(resolvedQuery, 'freightClaimsInvoice')}
                onChange={handleChange}
              />
            </FormGroup>
          )}
        </RequiresRole>

        {typeof immutableQuery.complaintRows === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.complaintImages === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.createdAt === 'undefined' && (
          <FormGroup>
            <Label>Skapad</Label>
            <DateRangePicker
              name="createdAt"
              value={_.get(resolvedQuery, 'createdAt')}
              onChange={handleChange}
            />
          </FormGroup>
        )}
        {typeof immutableQuery.updatedAt === 'undefined' && (
          <FormGroup>
            <Label>Uppdaterad</Label>
            <DateRangePicker
              name="updatedAt"
              value={_.get(resolvedQuery, 'updatedAt')}
              onChange={handleChange}
            />
          </FormGroup>
        )}
      </SecureFormsy>
      {isModal && (
        <Button onClick={reset} className="mt-3">
          Rensa filter
        </Button>
      )}
    </>
  );
}

ComplaintFilterPanel.propTypes = {
  querySpecification: PropTypes.object,
  immutableQuery: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  isSubForm: PropTypes.bool,
  isModal: PropTypes.bool,
};

ComplaintFilterPanel.defaultProps = {
  querySpecification: defaultActionValues(),
  immutableQuery: {},
  isSubForm: false,
  isModal: false,
};

function ComplaintFilterPanelModal({
  onSubmit,
  querySpecification,
  immutableQuery,
}) {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  const handleChange = newQuerySpecification => {
    onSubmit(newQuerySpecification);
  };

  const applyFilters = () => {
    setIsOpen(false);
  };

  return (
    <>
      <Modal toggle={toggle} isOpen={isOpen} centered scrollable>
        <ModalHeader toggle={toggle}>Filtrera</ModalHeader>
        <ModalBody>
          <Row>
            <Col>
              <ComplaintFilterPanel
                onChange={handleChange}
                querySpecification={querySpecification}
                immutableQuery={immutableQuery}
                isModal
              />
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Row>
            <Col>
              <Button
                onClick={applyFilters}
                color="primary"
                className="float-end mt-3"
              >
                Stäng
              </Button>
            </Col>
          </Row>
        </ModalFooter>
      </Modal>
      <Button color="outline-secondary" onClick={toggle}>
        Filtrera
      </Button>
    </>
  );
}

ComplaintFilterPanelModal.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  querySpecification: PropTypes.object,
  immutableQuery: PropTypes.object,
};

ComplaintFilterPanelModal.defaultProps = {
  querySpecification: null,
  immutableQuery: {},
};

module.exports = { ComplaintFilterPanel, ComplaintFilterPanelModal };
